/**
 * @file HttpStatus.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los códigos de estado HTTPStatus
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-12-19
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

export const HTTPStatus = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  PRECONDITION_FAILED: 412,
  CONTENT_TOO_LARGE: 413,
  IM_A_TEAPOT: 418,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  EXPIRED_TOKEN: 498,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

export type HTTPStatusValue = (typeof HTTPStatus)[keyof typeof HTTPStatus];
